import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
	locales: ["ar", "en"],
	defaultLocale: "ar",
	localePrefix: "always",
	// next-intl 4 made NEXT_LOCALE a session cookie; v3 defaulted it to a year.
	// The prefix is always in the URL, so this cookie only decides which locale
	// the unprefixed root redirects to — keeping it persistent preserves the
	// pre-upgrade behaviour where LocaleSwitcher's choice outlived the session.
	localeCookie: { maxAge: 60 * 60 * 24 * 365 },
});

export type Locale = (typeof routing.locales)[number];

export function isRtl(locale: string): boolean {
	return locale === "ar";
}
